import Cookies from 'js-cookie';
import snq from 'snq';

export function getRootDomain(domain) {
  // if (process.env.NODE_ENV === 'development') return "localhost";
  if (window.location.hostname === 'localhost') return 'localhost';
  var dotcount = domain.split('.').length - 1;
  if (dotcount == 1) dotcount = dotcount + 1;
  return domain
    .split('.')
    .slice(dotcount * -1)
    .join('.');
}

export const slugify = string => {
  const a = 'àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;';
  const b = 'aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------';
  const p = new RegExp(a.split('').join('|'), 'g');

  return string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
};

export function cookiesToLocalStorage() {
  const BETS_STORAGE_KEY = 'bets';
  const SELECTIONS_STORAGE_KEY = 'selections';
  const GAME_DETAILS_STORAGE_KEY = 'game_details';
  const ROUND_ROBIN_STORAGE_KEY = 'ROUND_ROBIN_STORAGE_KEY';
  const CHECKED_SELECTION_IDS = 'CHECKED_SELECTION_IDS';

  if (Cookies.get(BETS_STORAGE_KEY) && Cookies.get(BETS_STORAGE_KEY).length > 2) {
    localStorage.setItem(BETS_STORAGE_KEY, Cookies.get(BETS_STORAGE_KEY));
    Cookies.remove(BETS_STORAGE_KEY, {
      path: '/',
      domain: getRootDomain(location.hostname),
    });
  }

  if (Cookies.get(SELECTIONS_STORAGE_KEY) && Cookies.get(SELECTIONS_STORAGE_KEY).length > 2) {
    localStorage.setItem(SELECTIONS_STORAGE_KEY, Cookies.get(SELECTIONS_STORAGE_KEY));
    Cookies.remove(SELECTIONS_STORAGE_KEY, {
      path: '/',
      domain: getRootDomain(location.hostname),
    });
  }

  if (Cookies.get(GAME_DETAILS_STORAGE_KEY) && Cookies.get(GAME_DETAILS_STORAGE_KEY).length > 2) {
    localStorage.setItem(GAME_DETAILS_STORAGE_KEY, Cookies.get(GAME_DETAILS_STORAGE_KEY));
    Cookies.remove(GAME_DETAILS_STORAGE_KEY, {
      path: '/',
      domain: getRootDomain(location.hostname),
    });
  }

  if (Cookies.get(ROUND_ROBIN_STORAGE_KEY) && Cookies.get(ROUND_ROBIN_STORAGE_KEY).length > 2) {
    localStorage.setItem(ROUND_ROBIN_STORAGE_KEY, Cookies.get(ROUND_ROBIN_STORAGE_KEY));
    Cookies.remove(ROUND_ROBIN_STORAGE_KEY, {
      path: '/',
      domain: getRootDomain(location.hostname),
    });
  }

  if (Cookies.get(CHECKED_SELECTION_IDS) && Cookies.get(CHECKED_SELECTION_IDS).length > 2) {
    localStorage.setItem(CHECKED_SELECTION_IDS, Cookies.get(CHECKED_SELECTION_IDS));
    Cookies.remove(CHECKED_SELECTION_IDS, {
      path: '/',
      domain: getRootDomain(location.hostname),
    });
  }
}

export function flatten(input) {
  const stack = [...input];
  const res = [];
  while (stack.length) {
    // pop value from stack
    const next = stack.pop();
    if (Array.isArray(next)) {
      // push back array items, won't modify the original input
      stack.push(...next);
    } else {
      res.push(next);
    }
  }
  // reverse to restore input order
  return res.reverse();
}

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const modifyAmountInput = evt => {
  evt = evt ? evt : window.event;
  const charCode = evt.which ? evt.which : evt.keyCode;
  const value = evt.target.value;

  const hasDot = snq(() => value.includes('.'));
  // dont allow second dot
  if (hasDot && charCode === 46) {
    evt.preventDefault();
  }

  const length = snq(() => value.split('.')[1].length);
  // can be write onlyy 121.11 (only allow two decimal)
  if (hasDot && length === 2) {
    evt.preventDefault();
  }

  if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
    evt.preventDefault();
  } else {
    return true;
  }
};
